export default function () {
  return {
    permCMS0: [
      'UserList',
      'AdditionalInterestDatabase',
      'SourceDatabase',
      'FolderLocations',
      'PolicySetup',
      'FormLetters',
      'ClientScreenSetup',
      'GeneralConfig',
      'EmailSetup',
      'AddToMenus',
      'UnmatchedDocuments',
      'DocumentsForReview',
      'LogTemplates',
      'CrossSellItems',
      'DirectIntegration',
      'InsertClients',
      'BatchEmail',
      'AttachmentDescriptions',
      'BatchLog',
      'HawkLinkMapping',
      'ChangeClientProducerCSR',
      'NoTextingAdmin',
      'NoEditPolicyHistory',
      'Submissions',
      'Integration',
      'CloudSignin'
    ].reduce(assignIntV(), {}),
    permCMS1: [
      'ClientStatusActive',
      'ClientStatusDeadFiled',
      'ClientStatusProspectOrLead',
      'ClientTypeAgency',
      'ClientTypeAgent',
      'ClientTypeCarrier',
      'ClientTypeCustomer',
      'ClientTypeEmergencyContact',
      'ClientTypeOther',
      'ClientTypePersonal',
      'ClientTypeVendor',
      'CustomerTypeCommercial',
      'CustomerTypeCrossSell',
      'CustomerTypeLife',
      'CustomerTypePersonal',
      'ActionMenu',
      'AllowUnflaggingExclusiveFlags',
      'AllowVoidingOfLogs',
      'ArchiveAndMovePolicies',
      'ArchiveClient',
      'ChangeAgent1',
      'ChangeAgent2',
      'ChangeAgent3',
      'ChangeAgentCode',
      'ChangeClientTypeStatusAndOffice',
      'ChangeInceptionDate',
      'ChangeOffice',
      'ChangePolicyInfo',
      'DeleteAndArchiveAttachments',
      'DuplicatePolicy',
      'EditAttachmentProperties',
      'EditCarrierCommission',
      'EditPolicyCommission',
      'InsertPolicies',
      'InternalAcordForms',
      'InternalCorrection',
      'InternalMenu',
      'InternalPrint',
      'InternalQuote',
      'InternalScan'
    ].reduce(assignIntV(), {})
  };
}
// maps 1,2,4,8 values to ea enum because I'm too lazy to type it out
function assignIntV () {
  var i = 0;
  return function (acc, p) {
    if (i === 4) i = 0;
    return { ...acc, [p]: Math.pow(2, i++) };
  };
}
